import React from "react";
import { Link } from "react-router-dom";
import LogoImg from "./img/logo.png";
import { useSelector } from "react-redux";

const Header = () => {
  const cartProducts = useSelector((state) => state.cartItems);

  // this function will return total quantity the cart items ...
  const totalQuantity = (products) => {
    if (products?.length === 0) return 0;

    let quantity = products?.reduce((total, item) => {
      return Number(item?.quantity) + total;
    }, 0);

    return quantity;
  };

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <Link to="/">
          <img src={LogoImg} alt="LWS" className="max-w-[140px]" />
        </Link>

        <div className="flex gap-4">
          <Link to="/" className="navHome" id="lws-home">
            {" "}
            Home{" "}
          </Link>
          <Link to="/cart" className="navCart" id="lws-cart">
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{totalQuantity(cartProducts)}</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;
